<template>
  <avtalat-icon v-if="showAvtalatIcon()" class="mr-1 text-text-primary" :id="kanalIcon()" :title="KanalTypeLabels[kanal]" :size="24" />
  <font-awesome-icon v-else class="mr-1" :icon="kanalIcon()" :title="KanalTypeLabels[kanal]" />
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { KanalType } from "@/composables/KundserviceAppApiClient";
import { KanalTypeLabels } from "@/common/constants";

const props = defineProps<{
  kanal: KanalType;
}>();

const kanalIcon = () => {
  switch (props.kanal) {
    case KanalType.Telefon:
      return "fa-regular fa-phone";
    case KanalType.Epost:
      return "fa-regular fa-envelope";
    case KanalType.Chat:
      return "fa-regular fa-comments";
    case KanalType.Freshdesk:
      return "fa-regular fa-database";
    case KanalType.InloggadPaAvtalatSe:
      return "fa-regular fa-desktop";
    case KanalType.Kundservice:
      return "fa-regular fa-headset";
    case KanalType.Radgivningstjansten:
      return "fa-regular fa-user";
    case KanalType.DigitaltMote:
      return "dator-1";
    case KanalType.FysisktMote:
      return "mote";
    default:
      return "fa-regular fa-circle-question";
  }
};

const showAvtalatIcon = () => {
  return (
    props.kanal === KanalType.DigitaltMote ||
    props.kanal === KanalType.FysisktMote
  );
};

</script>
